import LegalPage from "../../components/LegalPage";

export default function Confidentialite() {
  return (
    <LegalPage title="Politique de confidentialité" kicker="Confidentialité">
      <h2>1. Données collectées</h2>
      <p>
        OTRAQUIZZ collecte uniquement les données strictement nécessaires
        au fonctionnement du service : adresse email, pseudo, historique
        des codes et sessions, IBAN uniquement pour les versements de gains.
      </p>
      <h2>2. Finalités</h2>
      <p>
        Les données sont utilisées pour gérer les comptes, les paiements,
        les classements et le versement des gains. Aucune donnée n&apos;est
        revendue.
      </p>
      <h2>3. Hébergement</h2>
      <p>
        Les données sont hébergées au sein de l&apos;Union Européenne. Les
        paiements transitent par Stripe (PCI-DSS).
      </p>
      <h2>4. Droits du joueur</h2>
      <p>
        Conformément au RGPD, le joueur dispose d&apos;un droit
        d&apos;accès, de rectification, d&apos;effacement et de portabilité
        de ses données. Voir la page « Données personnelles ».
      </p>
      <h2>5. Conservation</h2>
      <p>
        Les données de jeu sont conservées tant que le compte est actif.
        Les données de paiement sont conservées conformément aux durées
        légales en vigueur.
      </p>
    </LegalPage>
  );
}
